<div class="overview">
  @for (item of items; track item) {
    <div class="overviewitem">
      <span [ngStyle]="{'background-color': item.background}" class="item census">{{item.title}}</span>
      <span class="overviewdata">{{item.value}}</span>
    </div>
  }
</div>
